import { render, staticRenderFns } from "./PostCard.vue?vue&type=template&id=21a0060d&scoped=true&"
import script from "./PostCard.vue?vue&type=script&lang=ts&"
export * from "./PostCard.vue?vue&type=script&lang=ts&"
import style0 from "./PostCard.vue?vue&type=style&index=0&id=21a0060d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a0060d",
  null
  
)

export default component.exports